const ms = require('ms');
const _ = require('lodash');

exports.sleep = async function sleep(interval) {
  let intervalMS = interval;
  if (_.isString(intervalMS)) intervalMS = ms(intervalMS);

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, intervalMS);
  });
};
